import { RPInstance } from './base';

const mainApi = {};

// 헤더의 포인트 리스트 조회 (thumbnail img 포함)
mainApi.getPointThumbnailList = () => {
  return RPInstance.get('main/gnb');
};

// 인트로 페이지의 포인트 리스트 조회 (list img 포함)
mainApi.getPointList = () => {
  return RPInstance.get('main/intro');
};

export default {
  ...mainApi,
};
